import { InjectionToken, Type } from '@angular/core';

import { UnknownTaskComponent } from '../components/unknown-task/unknown-task.component';
import { TaskContainer } from '../containers/task-container/task-container.component';
import { Task } from '../entities/task.entity';

export const TASK_CONTAINER = new InjectionToken<TaskContainer[]>('task-container');
export class TaskContainerFactoryComponentService {
    readonly components: Map<string, Type<TaskContainer>> = new Map();

    registerComponent(taskInfoKey: string, type: Type<TaskContainer>) {
        this.components.set(taskInfoKey, type);
    }

    getComponent(task: Task): Type<TaskContainer> {
        const key = task.task.TaskInfo.Key;
        if (this.components.has(key)) {
            return this.components.get(key)!;
        } else {
            console.error(`No component found for key ${key}`);
            return UnknownTaskComponent;
        }
    }
}
